<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="130px">
          <el-row>
            <!-- FPA编号 -->
            <el-col :span="8">
              <el-form-item :label="$t('material.fpaNo')" prop="fpaNo">
                <el-input v-model="queryCondition.fpaNo" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- 未来开始时间 -->
            <el-col :span="8">
              <el-form-item :label="$t('material.validFrom')" prop="validFrom">
                <el-date-picker v-model="queryCondition.validFrom" type="date" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsStart"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="至" prop="validFromEnd">
                <el-date-picker v-model="queryCondition.validFromEnd" type="date" value-format="yyyy-MM-dd" :picker-options="AgreementPickerOptionsEnd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 是否已下发 -->
            <el-col :span="8">
              <el-form-item :label="$t('material.isIssued')" prop="isIssued">
                <ic-select clearable table="TT_FPA" field="IS_ISSUED" v-model="queryCondition.isIssued"></ic-select>
              </el-form-item>
            </el-col>
            <!-- 下发时间 -->
            <el-col :span="8">
              <el-form-item :label="$t('material.issueTime')" prop="issueTime">
                <el-date-picker v-model="queryCondition.issueTime" type="date" value-format="yyyy-MM-dd" :picker-options="issueTimePickerOptionsStart"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="至" prop="issueEndTime">
                <el-date-picker v-model="queryCondition.issueEndTime" type="date" value-format="yyyy-MM-dd" :picker-options="issueTimePickerOptionsEnd"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 物料编号 -->
            <el-col :span="8">
              <el-form-item :label="$t('material.eightBitCode')" prop="eightBitCode">
                <el-input v-model.trim="queryCondition.eightBitCode" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button class="btn" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <!-- <el-button type="primary" @click="clickSelectMethod">{{$t('common.select')}}</el-button> -->
        <!--禁用-->
        <el-button class="btn" type="primary" @click="disableData">{{$t('material.statusDisable')}}</el-button>
        <!--重置-->
        <el-button class="btn" type="primary" @click="resetData()">{{$t('common.reset')}}</el-button>
        <!--确定-->
        <el-button class="btn" type="primary" @click="confirmData">{{$t('common.confirm')}}</el-button>
        <el-button class="btn" type="primary" @click="noFpa">无FPA下发</el-button>
      </el-row>
      <el-table :data="tableData" ref='tableData' border highlight-current-row class="table" :key="timeStamp" :row-key="(row)=>{return row.ttFpaPqcnId+row.type}" @selection-change="handleSelectionChange">
        <el-table-column v-if="multipleSelectionFlag" sortable prop="ttFpaPqcnId" type="selection" width="55" align="center" :reserve-selection="true" :selectable="(row)=>row.isIssuedI18n != '禁用'"></el-table-column>
        <el-table-column align="center" v-else width="55">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getTemplateRow(scope.row)" :label="scope.row.ttFpaPqcnId">&nbsp;
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('material.fpaNo')"></el-table-column>
        <!--FPA编号-->
        <el-table-column show-overflow-tooltip prop="eightBitCode" :label="$t('material.eightBitCode')"></el-table-column>
        <!--物料编号-->
        <el-table-column show-overflow-tooltip prop="eightBitCodeName" :label="$t('material.eightBitCodeName')"></el-table-column>
        <!--物料名称-->
        <el-table-column show-overflow-tooltip prop="newPricePerUom" :label="$t('material.newPricePerUom')"></el-table-column>
        <!--未来有效价格-->
        <el-table-column show-overflow-tooltip prop="validFrom" :label="$t('material.validFrom')"></el-table-column>
        <!--未来开始时间-->
        <el-table-column show-overflow-tooltip prop="updateDate" :label="$t('material.updateDate')"></el-table-column>
        <!--审批通过时间-->
        <el-table-column show-overflow-tooltip prop="isIssuedI18n" :label="$t('material.isIssued')"></el-table-column>
        <!--是否已下发-->
        <el-table-column show-overflow-tooltip prop="manualAssignmentDate" :label="$t('material.manualAssignmentDate')"></el-table-column>
        <!--手工指定有效期-->
        <el-table-column show-overflow-tooltip prop="mdmSynchronizationDate" :label="$t('material.mdmSynchronizationDate')"></el-table-column>
        <!--MDM同步日期-->
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!-- 禁用弹窗 -->
    <el-dialog :visible.sync="disableDialog" append-to-body width="30%" :title="$t('material.statusDisable')">
      <el-form :model="disableForm" ref="disableForm" :rules="disableRules" inline label-width="80px" class="disableForm">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('common.remarks')" prop="remarks" style="width:100%" class="disableFormRemarks">
              <el-input type="textarea" maxlength="300" :autosize="{ minRows: 2, maxRows: 4}" v-model="disableForm.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('common.attachment')">
              <el-upload ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.upload')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="fileList">
          <el-col :span="6" v-for="(item,index) in fileList" :key="index">
            <el-button type="text" @click="downloadFile(item)" icon="el-icon-download">{{item.documentName}}</el-button>
            <i class="el-icon-delete fileText" @click="deleteFile(item.tmDocumentId,index,fileList)"></i>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="disableDialog = false" type="primary">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="disableConfirm()">{{$t('common.confirm')}}</el-button>
      </div>
    </el-dialog>
    <!-- 手工指定有效期下放弹窗-->
    <el-dialog :title="$t('material.infoForm')" :visible.sync="issuePriceTakeEffectDateDialog" append-to-body width="500px">
      <el-form :model="issuePriceTakeEffectDateForm" ref="issuePriceTakeEffectDateForm" :rules="issuePriceTakeEffectDaterules" :label-position="labelPosition" label-width="140px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('material.issuePriceTakeEffectDate')" prop="issuePriceTakeEffectDate">
              <el-date-picker value-format="yyyy-MM-dd" v-model="issuePriceTakeEffectDateForm.issuePriceTakeEffectDate" type="date"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="issuePriceTakeEffectDateDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" @click="confirmToMDM">{{$t('common.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/material/material-master-data";
import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";

export default {
  components: { IcSelect },
  props: {
    multipleSelectionFlag: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
    },
    eightBitCodeList: {
      type: String,
    },
    fpaStatus: String,
    tmMaterialRecordId: {
      type: String,
    },
  },
  data() {
    var checkFile = (rule, value, callback) => {
      if (this.fileList.length < 1) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      } else {
        callback();
      }
    };
    return {
      isHaveParams: null,
      fpaStatus_c: this.fpaStatus,
      timeStamp: '',
      issuePriceTakeEffectDateDialog: false,
      issuePriceTakeEffectDateForm: {
        issuePriceTakeEffectDate: '',
      },
      issuePriceTakeEffectDaterules: {
        issuePriceTakeEffectDate: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
      },
      fileList: [],
      tsRecId: '',
      tableData: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        fpaNo: '',
        validFrom: '',
        validFromEnd: '',
        isIssued: '',
        issueTime: '',
        issueEndTime: '',
      },
      disableDialog: false,
      disableForm: {},
      disableRules: {
        remarks: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'blur' }],
        // uploadFile:[{ required: true, trigger: ["change"],validator: checkFile  }],
        uploadFile: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: 'change' }],
      },
      multipleSelection: [],
      supplierStatusList: [],
      getRowKeys(row) {
        return row.tmSupplierId;
      },
      selectRows: [],
      categoryList1: [],
      categoryList2: [],
      radioVal: null,
      AgreementPickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.validFromEnd;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      AgreementPickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.validFrom;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
      issueTimePickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.issueEndTime;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      issueTimePickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.issueTime;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    }
  },
  created() {
    this.queryData(1);
  },
  watch: {
    fpaStatus(newValue) {
      this.fpaStatus_c = newValue;
    }
    // visible() {
    //     this.$refs.supplierSelectTabel.clearSelection();
    // }
  },
  methods: {
    //查询承运商
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      this.queryCondition.eightBitCodeList = this.eightBitCodeList
      apiService.getFPAList(this.queryCondition).then((res) => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        that.timeStamp = !that.timeStamp
      })
    },
    restQueryForm() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryData();
    },
    //确定
    confirmData() {
      //如果用户选择多个物料，但是FPA未选择同等数量的FPA，则提示：物料:XXXX,XXX尚未选择FPA，请进行选择；
      //如果同一物料选择了多个不同的FPA，则提示：物料XXXX,XXX选择了多个FPA，相同物料只能选择一个FPA；
      let that = this
      that.isHaveParams = "Y"
      let materielLen = that.eightBitCodeList.length
      let rows = this.selectRows
      console.log(rows)
      if (rows.length == 0) {
        this.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
      } else {
        var obj = {};
        //对选择的所有物料去重
        let AlleightBitCode = rows.reduce(function (item, next) {
          obj[next.eightBitCode] ? '' : obj[next.eightBitCode] = true && item.push(next.eightBitCode);
          return item;
        }, []); //设置item默认类型为数组，并且初始值为空的数组
        if (AlleightBitCode.length < materielLen) {
          // 差集 数组AlleightBitCode相对于that.eightBitCodeList所没有的
          let diff = that.eightBitCodeList.filter(function (val) { return AlleightBitCode.indexOf(val) === -1 })
          this.$message({ message: diff.join(",") + '尚未选择FPA，请进行选择', type: "warning" });
        } else {
          let eightBitCodeArr = []
          let eightBitCodeArrRepeat = []
          //获取所有 物料编号重复的
          for (var x = 0; x < rows.length; x++) {
            for (var y = 0; y < rows.length; y++) {
              if (rows[x].eightBitCode == rows[y].eightBitCode && x != y) {
                eightBitCodeArr.push(rows[x].eightBitCode)
              }
            }
          }
          if (eightBitCodeArr.length > 0) {
            eightBitCodeArrRepeat = Array.from(new Set(eightBitCodeArr))
            let tipStr = eightBitCodeArrRepeat.join(",");
            that.$message({ message: tipStr + '选择了多个FPA，相同物料只能选择一个FPA', type: "warning" });
          } else {
            for (let i = 0; i < rows.length; i++) {
              if (rows[i].isIssued == 'issued') {//已下发("issued")
                that.$message({ message: 'FPA价格已下发，若需重新下发，请点击重置', type: "warning" });
                return false;
              }
            }
            that.issuePriceTakeEffectDateDialog = true
          }
        }
      }
      // if(this.selectRows.length==0){
      //     this.$message({message: this.$t('common.pleaseSelectOneData'), type: "warning"});
      //     return false;
      // }else if(that.selectRows[0].isIssued=='not_issued' || that.selectRows[0].isIssued=='distribution_failed'){//未下发("not_issued"),下发失败("distribution_failed");
      //     that.issuePriceTakeEffectDateDialog = true
      // }else if(that.selectRows[0].isIssued=='issued'){//已下发("issued"),当前FPA价格已下发，若需重新下发，请点击重置
      //     that.$message({message: that.$t('material.Issued'), type: "warning"});
      // }else if(that.selectRows[0].isIssued=='disable'){//FPA已禁用，无法下发
      //     that.$message({message: that.$t('material.yesDisable'), type: "warning"});
      // }
    },
    noFpa() {
      this.isHaveParams = "N"
      this.issuePriceTakeEffectDateDialog = true
    },
    confirmToMDM() {
      let that = this
      this.$refs['issuePriceTakeEffectDateForm'].validate((valid) => {
        if (valid) {
          let rows = this.selectRows;
          console.log("🚀 ~ this.isHaveParams", this.isHaveParams)
          var pramas={}
          if (this.isHaveParams === "Y") {
            this.$set(pramas,'materialRecordIdList',that.tmMaterialRecordId)
            this.$set(pramas,'ttFpaPqcnIdList',rows.map(v => { return v.ttFpaPqcnId }))
            this.$set(pramas,'ttFpaPqcnIdTypeList',rows.map(v => { return v.fpaPqcnByTypeId }))
            this.$set(pramas,'rpfStatusForMdm',that.fpaStatus)
            this.$set(pramas,'issuePriceTakeEffectDate',that.issuePriceTakeEffectDateForm.issuePriceTakeEffectDate)
          }else{
            this.$set(pramas,'materialRecordIdList',that.tmMaterialRecordId)
            this.$set(pramas,'rpfStatusForMdm',that.fpaStatus)
            this.$set(pramas,'issuePriceTakeEffectDate',that.issuePriceTakeEffectDateForm.issuePriceTakeEffectDate)
          }
          console.log("pramas", pramas)
          apiService.sendMaterialToMDM(pramas, false).then((res) => {
            if (res.data) {
              that.$message({ message: this.$t('common.operateSuccess'), type: "success" });
              that.issuePriceTakeEffectDateDialog = false
              that.issuePriceTakeEffectDateForm.issuePriceTakeEffectDate = ''
              that.queryData();
            } else {
              that.$message({ message: res.msg, type: "error" });
            }
          });
        } else {
          return false;
        }
      })
    },
    //重置
    resetData() {
      let that = this
      let rows = this.selectRows
      if (that.selectRows.length == 0) {
        that.$message({ message: that.$t('common.pleaseSelectData'), type: "warning" });
        return false;
      }
      that.$confirm(that.$t('material.isReset'), that.$t('common.tips'), {
        confirmButtonText: that.$t('common.confirm'),
        cancelButtonText: that.$t('common.cancel'),
        customClass: 'colorBtn',
        type: 'warning'
      }).then(() => {
        let data = {
          idList: rows.map(v => { return v.ttFpaPqcnId }),
          operationStatus: 'reset',
        }
        console.log(data)
        apiService.funDisable(data).then((res) => {
          that.queryData()
          that.$message({ message: this.$t('common.operateSuccess'), type: "success" });
        })
      }).catch(() => {

      });
    },
    //禁用
    disableData() {
      let that = this
      if (that.selectRows.length == 0) {
        that.$message({ message: that.$t('common.pleaseSelectData'), type: "warning" });
        return false;
      }
      apiService.getLogId().then((res) => {
        that.tsRecId = res.data
        that.disableDialog = true
      })
    },
    //弹框中的确认禁用
    disableConfirm() {
      let that = this
      if (that.fileList.length < 1) {
        this.$message({ message: this.$t('common.uploadFile'), type: "warning" });
        return
      }
      this.$refs.disableForm.validate(valid => {
        if (valid) {
          let data = {
            idList: that.selectRows.map(v => { return v.ttFpaPqcnId }),
            // ttFpaPqcnId:that.selectRows[0].ttFpaPqcnId,
            remarks: that.disableForm.remarks,
            operationStatus: 'disable',
            workFlowId: that.tsRecId
          }
          // console.log(data)
          apiService.funDisable(data).then((res) => {
            that.queryData()
            that.$refs.tableData.clearSelection();
            that.disableDialog = false
            that.$message({ message: this.$t('common.operateSuccess'), type: "success" });
          })
        } else {
          return false;
        }
      });

    },
    //禁用中的上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = this.tsRecId;
        attachment.tsReckindId = 'MATERIAL_FPA';
        fileService.saveFile(attachment).then((saveRes) => {
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    downloadFile: function (row) {
      fileService.downloadFile(row)
    },
    deleteFile: function (tmDocumentId, index, files) {
      fileService.deleteFile(tmDocumentId).then(res => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess")
        });
        this.getFiles();
      });
    },
    getFiles() {
      let attachment = {};
      attachment.seq = "1";
      attachment.tsRecId = this.tsRecId;
      attachment.tsReckindId = 'MATERIAL_FPA';
      fileService.getFileList(attachment).then(fileRes => {
        this.fileList = fileRes;
      });
    },
    clickSelectMethod: function () {
      this.$emit('subCallMethod', this.selectRows);
      // if(this.selectRows.length==0){
      //     this.$message({message: "请选供应商", type: "warning"});
      // }else{
      //     this.$emit('subCallMethod', this.selectRows);
      // }
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows;
      this.selectRows = [];
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.selectRows.push(row);
          }
        });
      }
    },
    //单选操作
    getTemplateRow(row) {
      this.selectRows = [];
      this.selectRows.push(row);

    },
  },
  extends: commonFunction
}
</script>
<style scoped>
.el-select {
  width: 100%;
}
</style>
<style>
.disableForm .disableFormRemarks .el-form-item__content {
  width: 70%;
}
</style>
